import React from 'react'
import PropTypes from 'prop-types'
import Fade from 'react-reveal/Fade'

import IconWithMenu from 'components/IconWithMenu'
import styles from './styles.scss'

const IconWithMenuExtended = (props) => {
  const { children } = props

  return (
    <IconWithMenu className={styles.root} {...props}>
      {children}
    </IconWithMenu>
  )
}

IconWithMenuExtended.propTypes = {
  children: PropTypes.node,
}

export default IconWithMenuExtended
